var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "sign-up is-centered",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("img", { attrs: { src: _vm.logo, alt: "logo" } }),
      _c("h1", { staticClass: "title is-4 has-text-primary" }, [
        _vm._v("\n    Registro\n  ")
      ]),
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputName", {
              attrs: {
                value: _vm.name,
                disabled: _vm.loading,
                loading: _vm.loading,
                required: true
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputEmail", {
              attrs: {
                value: _vm.email,
                disabled: _vm.loading,
                loading: _vm.loading,
                required: true
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputPassword", {
              attrs: {
                value: _vm.password,
                disabled: _vm.loading,
                loading: _vm.loading,
                required: true
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12-mobile is-12-fullhd is-6" },
          [
            _c("AppInputPassword", {
              attrs: {
                id: "passwordConfirmation",
                name: "passwordConfirmation",
                label: "Repetir Contraseña",
                "error-message": "Las contraseñas no coinciden",
                value: _vm.passwordConfirmation,
                pattern: _vm.password,
                loading: _vm.loading,
                disabled: _vm.loading,
                required: true
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            })
          ],
          1
        )
      ]),
      _c("ButtonSubmit", {
        attrs: {
          loading: _vm.loading,
          disabled: _vm.loading,
          text: "regístrate"
        }
      }),
      _c("LinkSignIn"),
      _c("LinkForgottenPassword")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }